import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Sidebar from "./components/Sidebar";
import Edityourblogs from "./components/Edityourblogs";
import Editblogs from "./components/Editblogs";
import Login from "./components/Login";
import PendingBlogs from "./components/Pendingblogs";
import Currentusers from "./components/Currentusers";
import AddTestimonials from "./components/AddTestimonials";
import Addappreciation from "./components/Addappreciation";


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  return (
    <div className="app-container">
      {isLoggedIn && <Sidebar setIsLoggedIn={setIsLoggedIn} />}

      <div className="content-container">
        <Routes>
          <Route path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
          <Route path="/Edityourblogs" element={isLoggedIn ? <Edityourblogs /> : <Navigate to="/login" />} />
          <Route path="/editblog/:id" element={<Editblogs />} />
          <Route path="/pendingblogs" element={isLoggedIn ? <PendingBlogs /> : <Navigate to="/login" />} />
          <Route path="/" element={isLoggedIn ? <Editblogs /> : <Navigate to="/login" />} />
          <Route path="/currentusers" element={isLoggedIn ? <Currentusers /> : <Navigate to="/login" />} />
          <Route path="/testimonials" element={isLoggedIn ? <AddTestimonials /> : <Navigate to="/login" />} />
          <Route path="/add-employee-appreciation" element={isLoggedIn ? <Addappreciation /> : <Navigate to="/login" />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
